// Pill.tsx also considered a Badge
import React from "react";
import clsx from "clsx";

interface PillProps {
  text: any;
  className?: string; // Allows custom styles (e.g., colors, borders)
  variant?: "filled" | "outlined";
  icon?: React.ReactNode; // Add icon support
  truncate?: boolean; // Add option to truncate text
}

const Pill: React.FC<PillProps> = ({ 
  text, 
  className = "", 
  variant = "filled",
  icon, // Add icon to props
  truncate = false, // Default to false
}) => {
  const baseStyles =
    "inline-flex items-center gap-1 px-3 py-1 rounded-lg font-bold text-center";

  const variantStyles = {
    filled: "",
    outlined: "border border-current bg-transparent",
  };

  return (
    <span
      className={clsx(baseStyles, variantStyles[variant], className)}
    >
      {icon}
      <span className={truncate ? "truncate" : ""}>{text}</span>
    </span>
  );
};

export default Pill;